export class Model_SystemeInformation {
    ID: string;
    CODE_SYSTEME_INFORMATION: string;
    LIBELLE: string;
    VERSIONS: string[];
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
}

export class Model_User {
    ID: string;
    USERNAME: string;
    EMAIL: string;
    PASSWORD: string;
    PASSWORD_HASH: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    ROLE_ID: ROLE_USER;
}

export class Model_Agent {
    ID: string;
    NOM: string;
    PRENOM: string;
    USERNAME: string;
    EMAIL: string;
    PASSWORD: string;
    PASSWORD_HASH: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    ROLE_ID: ROLE_USER;
    CODE_SOCIETE: string;
    SOCIETE_ID: string;
    SOMMEIL: boolean;
    HAS_DEFAULT_PASSWORD: boolean;
}

export class AgentSaveRequestDTO {
    ID: string;
    USERNAME: string;
    EMAIL: string;
    PASSWORD: string;
    PASSWORD_HASH: string;
    SOCIETE_ID: string;
}

export class Model_TeamAssignationAgent {
    TEAM_ID: string;
    USER_ID: string;
    ASSIGNED: boolean;
    SUPERVISEUR: boolean;
    DATE_DEBUT_ASSIGNATION: Date;
    DATE_FIN_ASSIGNATION: Date;
    AGENT: Model_Agent;
}

export class Model_Societe {
    ID: string;
    CODE_SOCIETE: string;
    NOM_SOCIETE: string;
    NOM_BASE: string;
    DOMAINE: string;
    CONNECTION_STRING: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    CODE_SYSTEME_INFORMATION: string;
    VERSION_SYSTEME_INFORMATION: string;
    DATE_DEBUT_LICENCE: string;
    DUREE_LICENCE: number;
    DATE_EXPIRATION_LICENCE: string;

    STATUS_WORKSPACE?: INSTALLATION_STATUS_SOCIETE;

    RUNNER_USERNAME: string;
    RUNNER_DB_VERSION: string;
    RUNNER_SECRET_KEY: string;
    RUNNER_PASSWORD: string;
    RUNNER_DATE_INSTALLATION: string;
}

export class Model_Team {
    ID: string;
    CODE_SOCIETE: string;
    NOM: string;
    SOMMEIL: boolean;
    SOCIETE_ID: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
}

export class Model_Peripherique {
    ID: string;
    LABEL: string;
    ANDROID_ID: string;
    MAC_ADDRESS: string;
    IP_ADDRESS: string;
    SUBNET_MASK: string;
    DATE_CREATION: Date;
    DATE_MODIFICATION: Date;
    DATE_SUPPRESSION: Date;
    DATE_ACTIVATION: Date;
    SOMMEIL: boolean;
    IS_ENABLED: boolean;
    SOCKET_CONNECTION_ID: string;
    APP_VERSION_CODE: string;
    APP_VERSION_DISPLAY: string;
    DATE_LAST_MAJ: Date;
    MARQUE: string;
    MODELE: string;

    CODE_SOCIETE?: string;
    AGENT_USERNAME?: string;
    IS_CONNECTED: boolean;
}

export class Model_PeripheriqueAssignationAgent {
    PERIPHERIQUE_ID: string;
    UTILISATEUR_ID: string;
    SOCIETE_ID: string;
    CODE_SOCIETE: string;
    DATE_DEBUT_ASSIGNATION?: Date;
    DATE_FIN_ASSIGNATION?: Date;
    AGENT: Model_Agent;
    SOCIETE: Model_Societe;
}

export class PeripheriqueAssignationAgentSaveRequestDTO {
    PERIPHERIQUE_ID: string;
    UTILISATEUR_ID: string;
    SOCIETE_ID: string;
}

export class PeripheriqueSaveRequestDTO {
    ID: string;
    LABEL: string;
    MAC_ADDRESS: string;
    IP_ADDRESS: string;
    SUBNET_MASK: string;
    MARQUE: string;
    MODELE: string;
}

export class TeamSaveRequestDTO {
    ID: string;
    NOM: string;
    SOCIETE_ID: string;
}

export class TeamAssignationAgentSaveRequestDTO {
    SOCIETE_ID: string;
    ASSIGNATIONS: Model_TeamAssignationAgent[];
}

export class Model_Release {
    ID: string;
    NOM_RELEASE: string;
    APP_VERSION_CODE: string;
    APP_VERSION_DISPLAY: string;
    DATE_CREATION?: Date;
    DATE_MODIFICATION?: Date;
    DATE_SUPPRESSION?: Date;
    SOMMEIL: boolean;
    IS_PUBLISH: boolean;
    APP_FICHIER: string;
    RELEASE_NOTE: string;
    TAILLE_FICHIER: number;
    DATE_DEBUT_PUBLICATION?: Date;
    DATE_FIN_PUBLICATION?: Date;
}

export class ReleaseSaveRequestDTO {
    ID: string;
    NOM_RELEASE: string;
    APP_VERSION_CODE: string;
    APP_VERSION_DISPLAY: string;
}

export class BaseQueryParams {
    protected _maxPageSize: number = 500;
    PageSize: number = 10;
    PaginationEnabled: boolean = false;
    PageNumber: number = 1;
    OrderByColumn: string = "ID";
    OrderByDirection: string = "DESC";
    DateDebut?: Date;
    DateFin?: Date;
    IDS: number[];
    SearchValue: string = '';
    SOMMEIL_FILTER = -1;
}

export class AuthenticatedDTO {
    User: Model_User;
    AccessToken: string;
    RefreshToken: string;
}

export const SOMMEIL_FILTER_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: -1, mDISPLAY_MEMBER: "Tous" },
    { mVALUE_MEMBER: 1, mDISPLAY_MEMBER: "Actif" },
    { mVALUE_MEMBER: 0, mDISPLAY_MEMBER: "Inactif" }
];

export enum ROLE_USER {
    ADMIN = 1,
    USER = 2
}

export class AbsGrid<T> {
    mAbsColumns: AbsColumn[];
    mColumns: string[];
    mColumnNames: string[];
    mData: T[] = [];
    mGroups?: any[] = [];
  
    constructor() {
      this.mAbsColumns = [];
      this.mColumns = [];
      this.mColumnNames = [];
      this.mData = [];
    }
}

export class PaginatedResults<T> {
    mDatas: T[] = [];
    mCountTotal: number;
    mPageSize: number;
    mPageNumber: number;

    constructor() {
        this.mDatas = [];
        this.mCountTotal = 0;
        this.mPageSize = 0;
        this.mPageNumber = 0;
    }
}

export class AbsPaginatedGrid<T> {
    mAbsColumns: AbsColumn[];
    mColumns: string[];
    mColumnNames: string[];
    mPagination: PaginatedResults<T>;
    mTotalDatas: number;

    constructor() {
        this.mAbsColumns = [];
        this.mColumns = [];
        this.mColumnNames = [];
        this.mPagination = new PaginatedResults();
        this.mTotalDatas = 0;
    }
}

export class AbsColumn {
    mDatasource: string;
    mTitle: string;
    mType: TYPE_COLONNE;
    mTypeDonnees: TYPE_DONNEE;
    mVisible: boolean;
    mTemplate?: string;
    mHasCustomHtml: boolean;
    width?: number;
}

export enum TYPE_TEAM_ASSIGNATION {
    AGENT = 1,
    SUPERVISEUR
}

export enum TYPE_COLONNE {
    DIMENSION = 0,
    VALEUR = 1,
    VIRTUEL = 2
}

export enum TYPE_DONNEE {
    NUMERIQUE = 0,
    STRING = 1,
    DATETIME = 2,
    NUMERIQUE_POIDS = 3,
    NUMERIQUE_TEMPS = 4,
    NUMERIQUE_MONTANT = 5,
    BOOLEAN = 6,
    DATE = 7
}
export enum INSTALLATION_STATUS_SOCIETE {
    ALL = -1,
    DESACTIVE = 0,
    NON_INSTALLE = 1,
    INSTALLATION_EN_COURS = 2,
    INSTALLE = 3,
    MISE_A_JOUR_DISPONIBLE = 4,
    MISE_A_JOUR_EN_COURS = 5,
}

export enum SQL_TYPE_AUTHENTIFICATION {
    SQL_SERVER = 1,
    WINDOWS = 2
}

export class AbsDSOptionsItems {
    mVALUE_MEMBER: any;
    mDISPLAY_MEMBER: string; 
}

export class LiveNotification {
    TYPE_LIVE_NOTIFICATION: TYPE_LIVE_NOTIFICATION;
    NOTIFICATION_DATAS: any;
    ID?: string;
    MESSAGE?: string;
    SHOW_NOTIFICATION?: boolean;
}

export enum TYPE_LIVE_NOTIFICATION {
    PERIPHERIQUE_NEW_REGISTRATION_REQUEST = 1,
    PERIPHERIQUE_CONNECTED_DEVICES = 2,
    PUSH_MESSAGE = 3,
    PERIPHERIQUE_NEW_ASSIGNATION = 4
}

export class DeviceHubInfos {
    CONNECTION_ID: string;
    ANDROID_ID: string;
    DATE_CONNEXION: string;
}

export enum LICENCE_DURATIONS {
    ONE_MONTH = 1,
    ONE_YEAR = 2
}

export class Model_PeripheriqueLog {
    ID: string;
    FICHIER_LOG: string;
    TAILLE_FICHIER: number;
    DATE_CREATION: string;
    PERIPHERIQUE_ID: string;
    PERIPHERIQUE: Model_Peripherique;
}

export class Model_PeripheriqueDatabase {
    ID: string;
    LIBELLE: string;
    FICHIER_DATABASE: string;
    TAILLE_FICHIER: number;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    SOMMEIL: boolean;
    PERIPHERIQUE_ID: string;
    PERIPHERIQUE: Model_Peripherique;
}